export default __webpack_public_path__ + "static/media/preflop-equity-handvshand_0004_thumb.b5247670.jpg";